import React, { useState } from 'react';
import { Icon } from '../icons/Icon';
import { CollapsePanel } from '../product_detail/components/CollapsePanel';
import { CollapsePanelProps } from './CollapsePanelDesktop';
import styles from './CollapsePanelMobile.module.scss';

export const CollapsePanelMobile: React.FC<CollapsePanelProps> = ({ title, style, toggleStyle, children, ...props }) => {
  const isExternal = props.type === 'external-state';
  const initialActive = isExternal ? props.isActive : props.initialState === 'active';
  const [isActiveLocal, setIsActiveLocal] = useState<boolean>(initialActive);
  const isActive = isExternal ? props.isActive : isActiveLocal;
  const setIsActive = isExternal ? props.setIsActive : setIsActiveLocal;

  return (
    <CollapsePanel
      mobileOnly={true}
      panelStyle={{ width: '100%', backgroundColor: 'transparent', margin: 0, ...style }}
      wrapperStyle={{ border: 0, backgroundColor: 'transparent', padding: 0 }}
      toggleStyle={{
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: '1px solid black',
        padding: '10px 0 8px 0',
        position: 'relative',
        ...toggleStyle,
      }}
      useSmallIcon={true}
      active={isActive}
      toggle={() => setIsActive((prev) => !prev)}
      iconElement={<Icon name={isActive ? 'chevron-up' : 'chevron-down'} style={{ width: '9px', position: 'absolute', top: 12, right: 16 }} />}
      title={<div className={styles.collapsePanelToggleLabel}>{title}</div>}
    >
      {children}
    </CollapsePanel>
  );
};

export default CollapsePanelMobile;
